export enum Formule {
  CONF = 'CON2', //Confort
  CONFPlus = 'CON+2', //Confort +
  LM = 'LM',
  PAR = 'PAR2',
  TOU = 'TOU2',
  LIL = 'LIL2',
  SOL = 'SOL2',
  GRE = 'GRE', // Grenoble
  CRE = 'CRE', // Créteil
  MAR = 'MAR', // Marseille
  ETU = 'ETU', // Etudiant
  BSOL = 'BSOL',
}

export enum NatureResidence {
  Principale = 'Principale',
  Secondaire = 'Secondaire',
  ForRent = 'PourLocation',
  Etudiant = 'Etudiant',
}

export enum TypeHabitation {
  Appartement = 'Appartement',
  Maison = 'Maison',
  Autres = 'Autres',
  Chambre = 'Chambre',
}

export enum Lessor {
  Prive = 'Privé',
  Social = 'Social',
}

export enum LessorType {
  Arcade = 1,
  Contracted = 2, // Conventionné
  Altima = 3,
  AgreedUponMutualContent = 4, // Gré à gré
  NonContracted = 5, // Non conventionné
  Other = -1,
}

export enum SuperficieChambre {
  Undefined,
  CROUSMoinsDe10m2 = 'CROUSMoinsDe10m2',
  MoinsDe10m2 = 'MoinsDe10m2',
  De11a40m2 = 'De11a40m2',
  PlusDe40m2 = 'PlusDe40m2',
}

export enum QualiteOccupant {
  Proprietaire = 'Propriétaire',
  Locataire = 'Locataire',
}

export enum Etage {
  RezDeChaussee = 'Rez De Chaussée',
  Intermediaire = 'Intermédiaire',
  DernierEtage = 'Dernier étage',
}

export enum SurfaceDependance {
  Aucune = 'Aucune',
  De40a100m2 = '40-100m2',
  PlusDe100m2 = '100-250m2',
  PlusDe250m2 = '250m2',
  MoinsDe40m2 = '0-40m2',
  PlusDe40m2 = '40m2', // Etudiante ?
}

export enum TypePromo {
  Pourcentage = 'Pourcentage',
  MoisOfferts = 'MoisOfferts',
}

export enum TypeResilConcurrence {
  ChangeAssureur = 'ChangeAssureur',
  Emmenagement = 'Emmenagement',
}

export enum ValidityContractInsurance {
  LessThanOneYear = 'lessThanOneYear',
  MoreThanOneYear = 'moreThanOneYear',
}
